(function (_) {
    'use strict';

    _['MONDAY'] = 'Monday';
    _['TUESDAY'] = 'Tuesday';
    _['WEDNESDAY'] = 'Wednesday';
    _['THURSDAY'] = 'Thursday';
    _['FRIDAY'] = 'Friday';
    _['SATURDAY'] = 'Saturday';
    _['SUNDAY'] = 'Monday';
    _['MONDAY_SHORT'] = 'M';
    _['TUESDAY_SHORT'] = 'T';
    _['WEDNESDAY_SHORT'] = 'W';
    _['THURSDAY_SHORT'] = 'T';
    _['FRIDAY_SHORT'] = 'F';
    _['SATURDAY_SHORT'] = 'S';
    _['SUNDAY_SHORT'] = 'S';
    _['CHOOSE_CALENDAR'] = 'Choose a calendar';
    _['ALL_CALENDARS'] = 'All calendars';

    _['JANUARY'] = 'January';
    _['FEBRUARY'] = 'February';
    _['MARCH'] = 'March';
    _['APRIL'] = 'April';
    _['MAY'] = 'May';
    _['JUNE'] = 'June';
    _['JULY'] = 'July';
    _['AUGUST'] = 'August';
    _['SEPTEMBER'] = 'September';
    _['OCTOBER'] = 'October';
    _['NOVEMBER'] = 'November';
    _['DECEMBER'] = 'December';

    _['CALENDAR.KEY'] = 'Bookings';
    _['CALENDAR.MY_BOOKINGS'] = 'My bookings';
    _['MAKE_RESERVATION'] = 'Make a reservation';

    _['CALENDAR.DATE'] = 'Date';
    _['CALENDAR.DATE_PLACEHOLDER'] = 'Reservation date';
    _['CALENDAR.CANCEL_RESERVATION'] = 'Cancel booking';
    _['CALENDAR.INTERVAL'] = 'Hour';
    _['CALENDAR.INTERVAL_PLACEHOLDER'] = 'Select an hour';
    _['CALENDAR.MAX_ATTENDANTS'] = 'Number of persons';
    _['CALENDAR.COMMENTS'] = 'Comments';
    _['CALENDAR.COMMENTS_PLACEHOLDER'] = 'Write a comment...';
    _['CALENDAR.AVAILABLE'] = 'available';
    _['CALENDAR.EVENT_NOT_AVAILABLE'] = 'There is no place to make a reservation for the number of persons you entered. Maybe someone made a reservation while you were making yours.';
    _['CALENDAR.INVALID_EVENT'] = 'The selected hour is not valid.';
    _['CALENDAR.EVENT_PAST'] = 'The selected hour is in the past, you can not select it.';

    _['CALENDAR.BOOKING_SUCCESS_TITLE'] = 'You have successfully made a reservation';
    _['CALENDAR.BOOKING_SUCCESS_MSG'] = 'You have just made a reservation but you still have to receive a confirmation. When you receive the confirmation the reservation will be valid and you will be able to enjoy your reservation.';

    _['CALENDAR.NO-BOOKINGS'] = 'There are no bookings.';
    _['CALENDAR.STATUS'] = 'Status';
    _['CALENDAR.PENDING'] = 'Waiting';
    _['CALENDAR.ACCEPTED'] = 'Accepted';
    _['CALENDAR.USER_DENIED'] = 'Cancelled';
    _['CALENDAR.CREATOR_DENIED'] = 'Denied';
    _['CALENDAR.CALENDAR'] = 'Calendar';
    _['CALENDAR.ATTENDANTS'] = 'Attendants';

    _['BOOKINGS.MENU'] = 'My bookings';
}(translations['en']));



// WEBPACK FOOTER //
// ./src/app/modules/booking/lang/booking-lang_en.js